import React from 'react';
import PropTypes from 'prop-types';

export default function PromptOptionList({
  prompts,
  selectedPrompt,
  onSelect,
  busy,
  heading,
  scoreLabel = 'Confidence'
}) {
  if (!Array.isArray(prompts) || prompts.length === 0) {
    return (
      <div style={{ color: '#9ca3af', fontSize: 12 }}>Prompts are not available yet. Generate to continue.</div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      {!!heading && <div style={{ color: '#9ca3af', fontSize: 12 }}>{heading}</div>}
      <div style={{ display: 'grid', gap: 8 }}>
        {prompts.map((prompt) => {
          const text = String(prompt?.text || '').trim();
          if (!text) return null;
          const id = prompt?.id || text;
          const score = typeof prompt?.estimatedScore === 'number' ? prompt.estimatedScore : null;
          const isSelected = String(selectedPrompt || '') === text;
          return (
            <label
              key={id}
              style={{
                display: 'flex',
                gap: 12,
                alignItems: 'flex-start',
                border: isSelected ? '1px solid #ff5a1f' : '1px solid #1f2937',
                borderRadius: 8,
                padding: '8px 10px',
                background: isSelected ? 'rgba(255, 90, 31,0.12)' : '#111827',
                cursor: busy ? 'not-allowed' : 'pointer'
              }}
            >
              <input
                type="radio"
                name="prompt-option"
                value={text}
                checked={isSelected}
                disabled={busy}
                onChange={() => !busy && onSelect(text)}
                style={{ marginTop: 4 }}
              />
              <div style={{ display: 'grid', gap: 6 }}>
                <div style={{ color: '#e5e7eb', fontSize: 13, whiteSpace: 'pre-wrap' }}>{text}</div>
                {score !== null && (
                  <div style={{ color: '#9ca3af', fontSize: 12 }}>{scoreLabel}: {score}</div>
                )}
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}

PromptOptionList.propTypes = {
  prompts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    estimatedScore: PropTypes.number,
  })),
  selectedPrompt: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  heading: PropTypes.string,
  scoreLabel: PropTypes.string
};

PromptOptionList.defaultProps = {
  prompts: [],
  selectedPrompt: '',
  busy: false,
  heading: '',
  scoreLabel: 'Confidence'
};
